import gql from 'graphql-tag';

export const lastModifiedByFacetFragment = gql`
  fragment lastModifiedByFacetFragment on LastModifiedByFacet {
    dokkioClass
    count
    lastModifiedBy
  }
`;
export default lastModifiedByFacetFragment;
